import React from "react";
import { cx } from "class-variance-authority";
import { MethodRow } from "../method-row/MethodRow";
import * as styles from "./OptionRow.module.scss";

type OptionRowProps = {
  selected: boolean;
  disabled?: boolean;
  onSelect: () => void;
} & React.ComponentProps<typeof MethodRow>;

export const OptionRow = ({
  selected,
  disabled,
  onSelect,
  className,
  ...rowProps
}: OptionRowProps) => {
  return (
    <MethodRow
      role="radio"
      aria-checked={selected}
      disabled={disabled}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      className={cx(
        styles.option,
        selected && styles.active,
        disabled && styles.disabled,
        className,
      )}
      onClick={(event) => {
        if (event.defaultPrevented || disabled) return;
        onSelect();
      }}
      onKeyDown={(event) => {
        if (event.target !== event.currentTarget) return;
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          if (!disabled) onSelect();
        }
      }}
      {...rowProps}
    />
  );
};
